module.exports = __webpack_public_path__ + "static/media/BeautyandtheBesharam.ca0ea186.jpg";